import { getHeaders } from '../../utls/headerGenerator';
export async function updateAssociation(payload) {
  console.log('Payload:', payload); // Log the payload for debugging
  const options = {
    method: 'POST',
    headers: new Headers(await getHeaders()),
    mode: 'cors',
    credentials: 'omit',
    body: JSON.stringify(payload),
  };

  const endpoint = process.env.REACT_APP_BFF + '/updateAssociation';

  try {
    const response = await fetch(endpoint, options);

    if (response.ok) {
      // Response status code is in the 200-299 range (success)
      // const detailsResponse = await response.json();
      return true;
    } else {
      // Handle error responses (e.g., non-200 status codes)
      console.error(`Error: Received status code ${response.status}`);
      const errorDetails = await response.json(); // Try to parse error details if available
      return { error: response.status, details: errorDetails }; // Return an error object
    }
  } catch (err) {
    console.error('Fetch error:', err);
    return { error: 'FETCH_ERROR', details: err.message }; // Return a fetch error object
  }
}